export const HONORS_CLICK_ID = {
  JOIN_INITIATE_STANDARD: 'join_initiate',
  BOOK_RESERVATION: 'book_reservation',
  JOIN_HONORS_CHECK: 'join_honors_checked',
  JOIN_HONORS_UNCHECKED: 'join_honors_unchecked',
  PAGE_STOP: 'pagestoperror',
  FORM_VALIDATION: 'formvalidationerror',
} as const;

export const HONORS_ERRORS = {
  ERROR_TYPE: 'join',
} as const;

export const HONORS_UNIVERSAL_SEGMENTATION = {
  STANDARD_JOIN: 'standard_join',
  BOOK_NON_PRESUMPTIVE_JOIN: 'book_standard_join',
  BOOK_PRESUMPTIVE_JOIN: 'book_presumptive_join',
} as const;

export const HONORS_PAGE_PRIMARY_CATEGORY = {
  HONORS: 'honors',
  RESERVATION: 'reservation',
} as const;

export const HONORS_PAGE_TYPE = {
  JOIN: 'join',
  CONFIRMATION: 'confirmation',
} as const;

export const HONORS_PAGE_DETAIL_1 = {
  JOIN_HILTON_HONORS_FORM: 'join_hilton_honors_form',
  CONFIRMATION: 'confirmation',
} as const;
